import { Injectable }       from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ApiService }           from '../api/api.service';
import { ConfirmService }       from '../messages/confirm/confirm.service';
import { ProlinkSettingsModel } from './typings/prolink.settings';

@Injectable({
  providedIn: 'root'
})
export class ProlinkService {
  title = 'PROLink';

  constructor (
    private apiService      : ApiService,
    private confirmService  : ConfirmService,
    private translateService: TranslateService
  ) {}

  activate () : ng.IPromise<any> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATE', {
      name: this.title
    }))
    .then(() => this.apiService.get('/company/add_prolink'));
  }

  deactivate () : ng.IPromise<any> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.INTEGRATIONS.DEACTIVATE', {
      name: this.title
    }))
    .then(() => this.apiService.get('/company/remove_prolink'));
  }

  save ( settings : ProlinkSettingsModel ) : ng.IPromise<ProlinkSettingsModel> {
    return this.apiService.patch('/company', settings, 'company');
  }
}
